<form class="p-fluid p-formgrid p-grid" [formGroup]="userForm">
    <div class="p-field p-col-12 p-md-6">
        <label for="fname">First Name*</label>
        <input id="fname" type="text" pInputText formControlName="first">
    </div>
    <div class="p-field p-col-12 p-md-6">
        <label for="lname">Last Name*</label>
        <input id="lname" type="text" pInputText formControlName="last">
    </div>
    <div class="p-field p-col-12">
        <label for="email">Email*</label>
        <input id="email" type="email" pInputText formControlName="email" disabled>
    </div>
    <div class="p-field p-col-12">
        <label for="tzone">Time Zone</label>
        <p-dropdown inputId="tzone" [options]="tzones" formControlName="tzone" placeholder="Select a time zone" optionLabel="name" optionValue="code"></p-dropdown>
    </div>
    <div class="p-field p-col-12 p-md-3" *ngIf="userForm.disabled">
        <button pButton label="Edit" class="p-button-rounded p-button-info" (click)="editUser($event)"></button>
    </div>
    <div class="p-field p-col-12 p-md-3" *ngIf="userForm.enabled">
        <button pButton label="Save" class="p-button-rounded p-button-success" (click)="saveUser($event)"></button>
    </div>
    <div class="p-field p-col-12 p-md-3" *ngIf="userForm.enabled">
        <button pButton label="Cancel" class="p-button-rounded p-button-warning p-button-outlined" (click)="cancelEdit($event)"></button>
    </div>
</form>